import { graphql, useStaticQuery } from 'gatsby';
import { getTimelineData, getBilateralList, getImageTextCard } from '../utils/utils';

function getWhoWeArepageData() {
  const data = useStaticQuery(graphql`
    query WhoWeArePageQuery {
      allSanityPage(filter: { slug: { current: { eq: "who-we-are" } } }) {
        edges {
          node {
            _rawBody
          }
        }
      }
    }
  `).allSanityPage.edges[0].node._rawBody;
  const whoWeAreData = getTimelineData(data);
  const { bilateralList, layoutStyle } = getBilateralList(data);
  const bilateralList2 = getBilateralList(data,1);
  whoWeAreData.bilateral2 = bilateralList[1];
  whoWeAreData.someText = bilateralList[0]?.textComponent.description;
  whoWeAreData.links = bilateralList[0]?.textComponent.links.data;
  whoWeAreData.dogImage = bilateralList[0]?.bilateralImage.webUrl;
  whoWeAreData.dataForTl = getImageTextCard(data);
  return whoWeAreData;
}

export default getWhoWeArepageData;
